import { forwardRef } from 'react'
import { Box, Flex, Text, Select } from '@chakra-ui/react'

export const CustomSelectOmni = forwardRef(({ label, placeholder, error, isDisabled = false, children, ...rest }, ref) => {
  return (
    <Flex
      position="relative"
      width="full"
      alignItems="center"
      border="1px solid"
      borderColor={error ? 'red.500' : '#313E44'}
      borderRadius="md"
      overflow="hidden"
      bg={isDisabled ? 'gray.100' : 'white'}
      _hover={{ borderColor: error ? 'red.600' : '#2A6990' }}
      _focusWithin={{ borderColor: '#378BBF', boxShadow: '0 0 0 1px #378BBF' }}
    >
      {label && (
        <Flex bg="transparent" height="100%" px="3" alignItems="center" borderRight="none">
          <Text fontSize="12px" fontWeight="medium" color="#313E44" whiteSpace="nowrap">
            {label}:
          </Text>
        </Flex>
      )}

      <Select
        flex="1"
        border="none"
        sx={{
          'padding-left': '0!important',
        }}
        _focus={{ boxShadow: 'none' }}
        fontSize="12px"
        placeholder={placeholder}
        isDisabled={isDisabled}
        bg={isDisabled ? 'gray.100' : 'white'}
        ref={ref}
        {...rest}
      >
        {children}
      </Select>
    </Flex>
  )
})

CustomSelectOmni.displayName = 'CustomSelectOmni'
